(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function handleCookieLinks(e) {
        e.preventDefault();
        if (typeof openAxeptioCookies === 'function') {
            openAxeptioCookies();
        } else {
            console.error('La fonction openAxeptioCookies n\'est pas disponible');
        }
    }

    const cookieSelectors = [
        'a[href="#gestiondescookies"]',
        'a[href="/en#gestiondescookies"]',  
        'a[href="/es#gestiondescookies"]',   
        'a[href="en#gestiondescookies"]',     
        'a[href="es#gestiondescookies"]',    
    ];

    const selector = cookieSelectors.join(', ');
    const cookieLinks = document.querySelectorAll(selector);

    cookieLinks.forEach(link => {
        link.addEventListener('click', handleCookieLinks);
    });

    if (window.location.hash === '#gestiondescookies') {
        if (typeof openAxeptioCookies === 'function') {
            openAxeptioCookies();
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ds-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Sélection des éléments
    const slider = document.querySelector('.testimonials-slider');
    const prevButtons = document.querySelectorAll('.prev-button');
    const nextButtons = document.querySelectorAll('.next-button');
    const cards = document.querySelectorAll('.testimonial-card');

    if (!slider || !cards.length) return;

    const cardWidth = cards[0].offsetWidth;
    const gap = 16;
    const scrollAmount = cardWidth + gap;

    const updateButtonsOpacity = () => {
      const isStart = slider.scrollLeft === 0;
      const isEnd = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth;

      prevButtons.forEach((button) => {
        button.style.opacity = isStart ? '0.5' : '1';
        button.style.pointerEvents = isStart ? 'none' : 'auto';
      });

      nextButtons.forEach((button) => {
        button.style.opacity = isEnd ? '0.5' : '1';
        button.style.pointerEvents = isEnd ? 'none' : 'auto';
      });
    };

    const scroll = (direction) => {
      slider.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth',
      });
    };

    prevButtons.forEach((button) => {
      button.addEventListener('click', () => scroll(-1));
    });

    nextButtons.forEach((button) => {
      button.addEventListener('click', () => scroll(1));
    });

    slider.addEventListener('scroll', updateButtonsOpacity);

    updateButtonsOpacity();
  });

  } catch(e) { console.error(e); }
})();
})();
